<div class="admin-controls-dialog">
  <h2 mat-dialog-title>特別対応</h2>
  <div mat-dialog-content>
    <mat-tab-group>
      <mat-tab label="準拠/非準拠の変更">
        <div class="tab-content">
          <mat-form-field>
            <mat-label>チーム選択</mat-label>
            <mat-select [(ngModel)]="selectedTeam" name="team" required>
              <mat-option
                *ngFor="let team of data.accountData"
                [value]="team.AccountID"
                >{{ team.AccountID }}</mat-option
              >
            </mat-select>
            <mat-error>チームを選択してください</mat-error>
          </mat-form-field>
          <div class="control-id-list">
            <mat-selection-list
              [(ngModel)]="selectedControlIds"
              name="controlIds"
              required
            >
              <mat-list-option
                *ngFor="let control of getControlsForFirstTeam()"
                [value]="control.ControlID"
              >
                {{ control.ControlID }}
              </mat-list-option>
            </mat-selection-list>
            <!-- <mat-error>コントロールを選択してください</mat-error> -->
          </div>
          <div class="selected-control-ids">
            <p>選択中のコントロールID:</p>
            <ul>
              <li *ngFor="let controlId of selectedControlIds">
                {{ controlId }}
              </li>
            </ul>
          </div>
          <div class="button-group">
            <button
              mat-raised-button
              color="primary"
              (click)="doneControl()"
              [disabled]="!selectedTeam || selectedControlIds.length === 0"
            >
              準拠にする
            </button>
            <button
              mat-raised-button
              color="warn"
              (click)="undoneControl()"
              [disabled]="!selectedTeam || selectedControlIds.length === 0"
            >
              非準拠にする
            </button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="直接ポイントを加点">
        <div class="tab-content">
          <mat-form-field>
            <mat-label>チーム選択</mat-label>
            <mat-select [(ngModel)]="selectedTeam" name="teamDirect" required>
              <mat-option
                *ngFor="let team of data.accountData"
                [value]="team.AccountID"
                >{{ team.AccountID }}</mat-option
              >
            </mat-select>
            <mat-error>チームを選択してください</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>加点するポイント</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="teamPoints"
              name="teamPoints"
              required
            />
            <mat-error>ポイントを入力してください</mat-error>
          </mat-form-field>
          <button
            mat-raised-button
            class="button"
            color="primary"
            (click)="assignTeamPoints()"
            [disabled]="!selectedTeam || !teamPoints"
          >
            加点する
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">閉じる</button>
  </div>
</div>
